export default "__VITE_ASSET__BUEYHz0f__"